import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { queryGetObjects } from 'app/backend/Common'
import { AccountTeamMember } from 'app/backend/salesforce-maps/AccountTeamMember'
import { ReduxOrganization, ReduxState, ReduxUser } from 'app/redux/ReduxInterfaces'
import { useSelector } from 'react-redux'

export function useAccountTeamMember (options = {}): UseQueryResult<AccountTeamMember | undefined> {
  const organization = useSelector<ReduxState, ReduxOrganization>(state => state.organization)
  const user = useSelector<ReduxState, ReduxUser>(state => state.user)
  const organizationId = organization.id
  const userId = user.userId

  return useQuery({
    queryKey: ['accountTeamMembers', organizationId, userId],
    refetchOnWindowFocus: false,
    enabled: Boolean(organizationId) && Boolean(userId),
    queryFn: async () => {
      console.log('Fetching account team members for:', organizationId)
      return await queryGetObjects({
        type: 'Account Team Member',
        select: [
          'UserId',
          'Id',
          'AccountAccessLevel',
          'TeamMemberRole',
          'User.Email',
          'User.Name'
        ],
        searchProps: {
          AccountId: organizationId
        }
      }).then(data =>
        data.find(org => org.userId === userId)
      ).catch(error => {
        console.error('Account team members query error:', error)
        throw error
      })
    },
    ...options
  })
}
